import React from 'react';
import styled from 'styled-components';
import AboutBanner from './about-banner';
import AboutContentRows from './about-content-rows';
import AboutBannerWave from './about-banner-wave';

import SEO from '../../seo';

const AboutContainer = styled.div``;

const About = ({ data }) => {
    const { about_page_acf, title } =
        (data && data.allWpPage.edges[0].node) || {};
    const {
        secondaryHeadline,
        pageColor,
        bannerCaption,
        bannerHeadline,
        contentRows,
        nextPageButton,
        waveButton,
        waveCaption,
        waveTitle,
        bottomBannerTitle,
        bottomBannerCaption,
        bottomBannerImage,
    } = about_page_acf || {};
    return (
        <AboutContainer>
            <SEO title={title} />
            <AboutBanner
                color={pageColor}
                headline={bannerHeadline}
                caption={bannerCaption}
                secondaryHeadline={secondaryHeadline}
            />
            <AboutContentRows color={pageColor} rows={contentRows} />
            <AboutBannerWave
                nextButton={nextPageButton}
                color={pageColor}
                title={waveTitle}
                caption={waveCaption}
                waveButton={waveButton}
                bbTitle={bottomBannerTitle}
                bbCaption={bottomBannerCaption}
                bbCaption={bottomBannerCaption}
                bbImage={bottomBannerImage}
            />
        </AboutContainer>
    );
};

export default About;
